var Lambda = require('aws-sdk/clients/lambda');
var S3 = require('aws-sdk/clients/s3');

import {Auth} from '../components/auth/cognito_auth';

export default {
	name: 'AudioGeneratorService',
	generateAudio (userInput, callack) {
		//return AxiosAjax.post('/generateAudio', body);
		var uploadFunction = new Lambda();
		var id_token = Auth.getIdToken();
		var encoding = userInput.format;
		if ('WAV' === encoding) {
			encoding = "LINEAR16";
		}
		var payload = JSON.stringify({
			"text": userInput.userScript,
			"langugeCode": userInput.language,
			"voiceName": userInput.voice,
			"audioEncodingEnum": encoding,
			"resultFileName": userInput.fileName,
			"idToken": id_token
		});

		//create JSON object for parameters for invoking Lambda function
		var pullParams = {
			FunctionName: process.env.VUE_APP_AWS_LAMBDA_ORDER_ARN,
			InvocationType: 'RequestResponse',
			LogType: 'Tail',
			Payload: payload
		};

		uploadFunction.invoke(pullParams, function(error, data) {
			if (error) {
				alert(error);
			} else {
				callack(data);
			}
		});
	},
	readMyFiles (callback) {
		var that = this;

		AWS.config.credentials.getPromise().then(function() {
				var s3 = new S3();
	      var params = {
	        Bucket: process.env.VUE_APP_AWS_BUCKET_CUSTOMER_PROJECTS_BUCKET,
	        Delimiter: '/',
	        Prefix: AWS.config.credentials.identityId + '/'
	      };

	      const requestCompletedFileName = "completed";
	      var promiseFiles = [];
	      var promiseCustomerInputs = [];
	      var resultFileList = [];

	      var promiseList = s3.listObjectsV2(params).promise();
	      promiseList.then(function(data) {

	    	  // list of folders
	    	  var folders = data.CommonPrefixes;
	    	  for (var f in folders) {
	    		  params.Prefix = folders[f].Prefix;
	    		  promiseFiles[f] = s3.listObjectsV2(params).promise();
	    	  }

	    	  // files in each folder
	    	  Promise.all(promiseFiles).then(function(values) {

	    		  // read customer_input.json from each folder
	    		  for (var v = 0; v < values.length; v++ ) {

	    			  var orderFulfillmentJsonKey = that.getOrderFulfillmentKey(values[v].Contents);
	    			  promiseCustomerInputs[v] = s3.getObject({Key: orderFulfillmentJsonKey, Bucket: params.Bucket}).promise();
	    			  var fileObj = {};
	    			  fileObj.fileKey = orderFulfillmentJsonKey;
	    			  //fileObj.fileCompleted = JSON.stringify(values[v]).includes(requestCompletedFileName);
	    			  resultFileList[v] = fileObj;

	    		  }
	    		  // assume values are in the same order as the promises that initiated them
	    		  Promise.all(promiseCustomerInputs).then(function(values) {
	    			  for (var c = 0; c < values.length; c ++) {
	    				  var jsonFileContent = JSON.parse(values[c].Body.toString('utf-8'));
	    				  resultFileList[c].fileName = jsonFileContent.mediaFileName;
	    				  resultFileList[c].fileType = jsonFileContent.mediaFileEncoding;
	    				  resultFileList[c].fileCompleted = jsonFileContent.downloadLink != null;
	    				  resultFileList[c].fileWords = jsonFileContent.usedWords;
	    				  resultFileList[c].scriptText = jsonFileContent.text;
	    				  resultFileList[c].fileExpiresAfter = jsonFileContent.downloadLinkExpiresAt;
	    				  resultFileList[c].fileLink = jsonFileContent.downloadLink;
	    			  }
	    			  callback(resultFileList);
	    		  });
		      });


	      }).catch(function(err) {
	        alert(err);
	      });
			}, function(err) {
				prompt(err);
			})
	},
	getOrderFulfillmentKey (objects) {
		var orderFulfillmentString = "order_fulfillment.json";
		for (var o in objects) {
			if (objects[o].Key.includes(orderFulfillmentString)) {
				return objects[o].Key;
			}
		}
		console.log(orderFulfillmentString + " NOT FOUND !!");
		return null;
	}

}
